<template>
    <div>
        <div class="table_description">
            <span>{{$t("user.apiKeys.description")}}</span>
        </div>
        <div class="table_head">
            <md-button class="md-blank" @click="showApiKeyModal({})">
                <span class>+</span>
                {{$t("user.apiKeys.button.add")}}
            </md-button>
        </div>
        <div class="flex">
            <div class="flex flex_column w_100">
                <ag-item :rowData="rowData"
                         :columnDefs="columnDefs"
                         v-on:sortChanged="sortChanged"
                         :with-title="true"
                         :with-description="true"
                         :with-header="true"
                />
                <Pagination
                    :totalNum="totalNum"
                    :pageSize="pageSize"
                    :sizeChange="sizeChange"
                    :currentChange="currentChange"
                    :currentPage="page"
                ></Pagination>
            </div>
        </div>
        <ApiKeyModal @add="addKey" @edit="updateKey" ref="apiKeyModal"></ApiKeyModal>
        <ApiKeyCreatedModal ref="apiKeyCreatedModal"></ApiKeyCreatedModal>
    </div>
</template>

<script>
import Pagination from "@/components/templates/common/Pagination";
import AgItem from "@/components/templates/agGrid/AgItem";
import PaginationParent from "@/components/templates/common/PaginationParent";
import {apiKeysApi} from "@/common/api/apiKeysApi";
import {asLocalizedDate} from "@/components/templates/agGrid/formatter/valueFormatters";
import ApiKeyModal from "@/views/user/profile/apiKeys/ApiKeyModal";
import ApiKeyCreatedModal from "@/views/user/profile/apiKeys/ApiKeyCreatedModal";

export default {
    extends: PaginationParent,
    components: {
        ApiKeyCreatedModal,
        ApiKeyModal,
        AgItem,
        Pagination,
    },
    data() {
        return {
            sorting: [],
            rowData: null,
            columnDefs: [
                {
                    headerName: this.$t("user.apiKeys.table.header.name"),
                    field: "name",
                    sortable: true,
                },
                {
                    headerName: this.$t("user.apiKeys.table.header.prefix"),
                    field: "prefix",
                    sortable: true,
                },
	            {
		            headerName: this.$t("user.apiKeys.table.header.usedByPartner"),
		            field: "usedByPartner",
		            cellRendererFramework: "BooleanAsIcon",
		            sortable: true,
	            },
                {
                    headerName: this.$t("user.apiKeys.table.header.lastUsed"),
                    field: "lastUsedTime",
                    valueFormatter: asLocalizedDate({ showTime: true }),
                    sortable: true,
                },
                {
                    headerName: this.$t("user.apiKeys.table.header.lastUpdated"),
                    field: "updateTime",
                    valueFormatter: asLocalizedDate({ showTime: true }),
                    sortable: true,
                },
                {
                    headerName: this.$t("common.creationDate"),
                    field: "creationTime",
                    valueFormatter: asLocalizedDate({ showTime: true }),
                    sortable: true,
                },
                {
                    headerName: this.$t("common.actions"),
                    minWidth: 120,
                    maxWidth: 120,
                    cellRendererFramework: "ApiKeysTableOperation",
                    cellRendererParams: {
                        editKey: this.showApiKeyModal,
                        deleteKey: this.deleteKey,
                    }
                },
            ],
        };
    },
    beforeMount() {
        this.getList();
    },
    methods: {
        sortChanged(sortData) {
            this.sorting = sortData;
            this.initPage();
            this.getList();
        },
        getList() {
            let postData = {
                columns: [],
                filters: [],
                maxResults: this.maxResults,
                offset: this.offset,
                sorting: this.sorting
            };

            apiKeysApi.inspection.list(postData)
                .then(res => {
                    this.setTotalNum(res.recordsTotal);
                    this.rowData = res.data;
                })
                .catch(e => {
                    this.toast(e);
                });
        },
        showApiKeyModal(data) {
            this.$refs.apiKeyModal.showWithData(data);
        },
        hideApiKeyModal() {
            this.$refs.apiKeyModal.show(false);
        },
        showApiKeyCreatedModal(data) {
            this.$refs.apiKeyCreatedModal.showWithData(data);
        },
        addKey(data) {
            apiKeysApi.operation.createNewKey(data)
                .then((clearTextKey) => {
                    this.hideApiKeyModal();
                    this.getList();
                    this.showApiKeyCreatedModal(clearTextKey);
                })
                .catch(this.toast);
        },
        updateKey(data) {
            apiKeysApi.operation.updateKey(data)
                .then((clearTextKey) => {
                    this.hideApiKeyModal();
                    this.getList();
                    if (clearTextKey) {
                        this.showApiKeyCreatedModal(clearTextKey);
                    } else {
                        this.toastSuccess();
                    }
                })
                .catch(this.toast);
        },
        deleteKey(data) {
            apiKeysApi.operation.deleteKey(data.id)
                .then(() => {
                    this.toastSuccess();
                    this.getList();
                })
                .catch(this.toast);
        }
    },
};
</script>